import { Stack, Flex, Text, Paper, Box } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import classes from "./index.module.css";
import { REPLAY_BLOCK_CLASS } from "../../utils/statsig";

interface Asset {
  name: string;
  value: number;
  share: number;
  color: string;
}

interface InsuranceAssetListProps {
  assets: Asset[];
}

export function InsuranceAssetList({ assets }: InsuranceAssetListProps) {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Paper p="sm" radius={"lg"} mb={"xl"} style={{ width: "100%" }}>
      <Stack
        justify="flex-start"
        gap="sm"
        align="flex-start"
        style={{ width: "100%" }}
      >
        {assets.map((asset, i) => (
          <Flex
            key={i}
            justify="flex-start"
            align="flex-start"
            style={{ width: "100%" }}
          >
            {/* Left column: Color indicator */}
            <Box
              className={classes.assetIndicator}
              bg={asset.color}
              style={{
                width: 20,
                height: 20,
                flexShrink: 0,
                marginTop: 2,
                marginRight: 10,
              }}
            />

            {/* Right column: Name and value/percentage */}
            <Stack gap={0} style={{ width: "calc(100% - 20px)" }}>
              {/* First row: Asset name */}
              <Text
                fw={isMobile ? 400 : 700}
                fz={isMobile ? "sm" : "md"}
                style={{ wordBreak: "break-word", width: "100%" }}
              >
                {asset.name}
              </Text>

              {/* Second row: Value and percentage */}
              <Flex justify="space-between" style={{ width: "100%" }}>
                <Text
                  fz={isMobile ? "sm" : "md"}
                  style={{ textAlign: "left" }}
                  className={REPLAY_BLOCK_CLASS}
                >
                  {asset.value.toLocaleString("sv-SE", {
                    style: "currency",
                    currency: "SEK",
                  })}
                </Text>
                <Text
                  fz={isMobile ? "sm" : "md"}
                  style={{ textAlign: "right" }}
                >
                  {(asset.share / 100).toLocaleString("sv-SE", {
                    style: "percent",
                    minimumFractionDigits: 2,
                  })}
                </Text>
              </Flex>
            </Stack>
          </Flex>
        ))}
      </Stack>
    </Paper>
  );
}
